var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudLightning = function SvgCloudLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 65.304C19.7853 63.3025 16.1372 60.2794 13.3878 56.5093C10.6384 52.7392 8.87468 48.3418 8.25709 43.7167C7.63949 39.0916 8.18756 34.3855 9.85148 30.0261C11.5154 25.6667 14.2424 21.7923 17.7846 18.755C21.3269 15.7176 25.572 13.6137 30.1342 12.6344C34.6964 11.655 39.4311 11.8314 43.9078 13.1474C48.3845 14.4635 52.4613 16.8774 55.7678 20.1699C59.0742 23.4623 61.5054 27.5289 62.8404 32H70.0004C74.6063 31.992 79.0401 33.7499 82.3892 36.912C85.7382 40.0741 87.7476 44.3997 88.0039 48.9986C88.2602 53.5974 86.7437 58.1195 83.7667 61.6341C80.7897 65.1486 76.5787 67.3883 72.0004 67.892",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48L40 68H56L44 88",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCloudLightning;